import Fetch, { V1 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';

export const getStockWatchlistGroup = () => {
  const resourceUrl = `${V1}stock/watchlist/group/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const postSelectWatchlistGroup = (id) => {
  const resourceUrl = `${V1}stock/watchlist/group/${id}/select/`;
  return Fetch.post(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const postStockWatchlistGroup = (payload) => {
  const resourceUrl = `${V1}stock/watchlist/group/`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const putStockWatchlistGroup = (payload) => {
  const resourceUrl = `${V1}stock/watchlist/group/`;
  return Fetch.put(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const delStockWatchlistGroup = (id) => {
  const resourceUrl = `${V1}stock/watchlist/group/${id}/`;
  return Fetch.delete(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getStockWatchlistProfile = () => {
  const resourceUrl = `${V1}stock/watchlist/group/profile/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getStockWatchlistMember = () => {
  const resourceUrl = `${V1}stock/watchlist/group/member/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const putStockWatchlistSortOrder = (id, type) => {
  const resourceUrl = `${V1}stock/watchlist/group/${id}/`;
  return Fetch.put(resourceUrl, type)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const postStockWatchlist = (stockCode) => {
  const resourceUrl = `${V1}stock/watchlist/`;
  return Fetch.post(resourceUrl, { code: stockCode })
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const delStockWatchlist = (stockCode) => {
  const resourceUrl = `${V1}stock/watchlist/${stockCode}/`;
  return Fetch.delete(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};




